import { useState, useEffect } from 'react';

interface HeaderProps {
  onMenuOpen: () => void;
}

export default function Header({ onMenuOpen }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`site ${scrolled ? 'scrolled' : ''}`} id="site-header">
      <div className="wrap nav">
        <a className={`brand ${!scrolled ? 'on-hero' : ''}`} href="#top" aria-label="Φροντιστήριο Πράξη — αρχική">
          <img src={`${process.env.PUBLIC_URL}/assets/logo-praksi.png`} alt="Φροντιστήριο Πράξη" id="brand-logo" />
        </a>
        <nav className="menu" aria-label="Κύρια πλοήγηση">
          <a href="#about">Φροντιστήριο</a>
          <a href="#why">Γιατί Πράξη</a>
          <a href="#stats">Επιτυχίες</a>
          <a href="#orient">Προσανατολισμός</a>
          <a href="#contact">Επικοινωνία</a>
        </nav>
        <div className="nav-cta">
          <a className="nav-phone" href="tel:+302251054070">
            <span aria-hidden="true">☎</span>
            <span className="lbl">22510&nbsp;54070</span>
          </a>
          <button
            className="burger"
            id="burger"
            aria-label="Άνοιγμα μενού"
            aria-expanded="false"
            onClick={onMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
}
